export default {
  namespaced: true,
  state: {
    id: "",
    nome: "",
    tipo: "",
    token: "",
    avatar: "",
    id_unidade: "",
    nome_unidade: "",
  },
  getters: {
    getUsuario(state) {
      return {
        id: state.id,
        nome: state.nome,
        tipo: state.tipo,
        token: state.token,
        avatar: state.avatar,
        unidade: {
          id_unidade: state.id_unidade,
          nome_unidade: state.nome_unidade,
        },
      };
    },

    USER_DATA(state) {
      return {
        id: state.id,
        nome: state.nome,
        avatar: state.avatar,
        id_unidade: state.id_unidade,
        nome_unidade: state.nome_unidade,
      };
    },
  },
  mutations: {
    setUsuario(state, payload) {
      //console.log(payload)
      state.id = payload.id;
      state.nome = payload.nome;
      state.tipo = payload.tipo;
      state.token = payload.token;
      state.avatar = payload.avatar;
      state.nome_unidade = payload.nome_unidade;
      state.id_unidade = payload.id_unidade;
    },
  },
  actions: {
    logIn: (context, payload) => {
      //console.log(payload);
      context.commit("setUsuario", payload);
    },
    logOff: (context) => {
      sessionStorage.clear();
      localStorage.clear();
      context.commit("setUsuario", {
        id: "",
        nome: "",
        tipo: "",
        token: "",
        avatar: "",
        nome_unidade: "",
        id_unidade: "",
      });
    },
  },
};
